import ReadOnlyService from '../base/ReadOnlyService';

class AssetCategory extends ReadOnlyService {
  constructor() {
    super('asset-categories');
  }
}

export default new AssetCategory();
